var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 344.417,
    height: 314.423,
    viewBox: "0 0 344.417 314.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_10",
    "data-name": "Ret\\xE2ngulo 10",
    width: 344.417,
    height: 314.423,
    transform: "translate(0)",
    fill: "#525252",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_1",
    "data-name": "Grupo de m\\xE1scara 1",
    transform: "translate(344.417 314.423) rotate(-180)",
    opacity: 0.44,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question-mark-svgrepo-com",
    transform: "translate(68.536)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M99.417,0C153.8,0,207.346,25.047,207.346,84.958c0,55.248-63.31,76.5-76.906,96.459-10.207,14.85-6.8,35.716-34.843,35.716-18.269,0-27.193-14.86-27.193-28.456,0-50.6,74.339-62.046,74.339-103.708,0-22.931-15.261-36.528-40.769-36.528-54.386,0-33.149,56.07-74.339,56.07C12.764,104.51,0,95.586,0,78.6-.01,36.929,47.567,0,99.417,0ZM97.3,244.716a34.853,34.853,0,1,1-34.853,34.853A35.01,35.01,0,0,1,97.3,244.716Z",
    fill: "#525252"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.30fe69df.svg";
export { ForwardRef as ReactComponent };